import { FC, useState } from "react";
import { ITabs, MuiTabPanel, MuiTabs } from "../../../../components";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS, PAGE_IDS } from "../../../../helpers/constants";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { BillingDetailsCheckboxState } from "../../modelsAndSchemas/Models";
import { billingAndPurchaseOrderKeys } from "../../siteCore/SiteCoreKeys";
import {
  BillingConfiguration,
  BillingConfigurationProps,
} from "../billingConfiguration/BillingConfiguration";
import { BillingDetails } from "../billingDetails/BillingDetails";
import { PurchaseOrderList } from "../purchaseOrderList/PurchaseOrderList";
import { BillingPurchaseOrderWrapper } from "./BillingPurchaseOrder.style";

interface BillingPurchaseOrderProps extends BillingConfigurationProps {
  checkboxState: BillingDetailsCheckboxState;
  updateCheckboxState: (key: string) => void;
  triggerAddContactModal?: () => void;
  isEditClient?: boolean;
}

const pageId = PAGE_IDS.BILLING_AND_PURCHASE_ORDER;
export const BillingPurchaseOrder: FC<BillingPurchaseOrderProps> = ({
  checkboxState,
  updateCheckboxState,
  isNewContactAdded,
  setIsNewContactAdded,
  onConfigOrProgramTemplateDeleted: onBillingConfigDeleted,
  triggerAddContactModal,
  isEditClient,
}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { fetchLabel } = useSiteCore();

  const {
    billingDetailsAndPOTitle,
    purchaseOrderTrackingTab,
    billingDetailsAndConfigurationTab,
  } = billingAndPurchaseOrderKeys;

  const tabBillingId = `${pageId}-tab1`;
  const tabPurchaseOrderId = `${pageId}-tab2`;
  const tabs: ITabs[] = [
    {
      id: tabBillingId,
      label: fetchLabel(
        billingDetailsAndPOTitle,
        billingDetailsAndConfigurationTab,
      ),
    },
    {
      id: tabPurchaseOrderId,
      label: fetchLabel(billingDetailsAndPOTitle, purchaseOrderTrackingTab),
    },
  ];

  const onTabChange = (event: React.ChangeEvent<{}>, value: number) => {
    setSelectedTab(value);
  };

  return (
    <BillingPurchaseOrderWrapper>
      <MuiTabs
        tabs={tabs}
        id={pageId}
        value={selectedTab}
        onChange={onTabChange}
        tabsTestIds={[tabBillingId, tabPurchaseOrderId]}
      >
        <MuiTabPanel
          ariaLabelledById={tabBillingId}
          panelId={`${pageId}-panel1`}
          value={selectedTab}
          index={0}
        >
          <>
            <BillingDetails
              checkboxState={checkboxState}
              updateCheckboxState={updateCheckboxState}
            />
            <PermissionWrapper
              permission={
                isEditClient
                  ? MODULE_PERMISSIONS.EDIT_CLIENT_BILLING_CONFIG
                  : MODULE_PERMISSIONS.ADD_CLIENT_BILLING_CONFIG
              }
            >
              <BillingConfiguration
                isNewContactAdded={isNewContactAdded}
                setIsNewContactAdded={setIsNewContactAdded}
                onConfigOrProgramTemplateDeleted={onBillingConfigDeleted}
                triggerAddContactModal={triggerAddContactModal}
              />
            </PermissionWrapper>
          </>
        </MuiTabPanel>

        <PermissionWrapper
          permission={MODULE_PERMISSIONS.VIEW_CLIENT_PURCHASE_ORDER}
        >
          <MuiTabPanel
            ariaLabelledById={tabPurchaseOrderId}
            panelId={`${pageId}-panel2`}
            value={selectedTab}
            index={1}
          >
            <PurchaseOrderList />
          </MuiTabPanel>
        </PermissionWrapper>
      </MuiTabs>
    </BillingPurchaseOrderWrapper>
  );
};
